import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  padding: 20px 0;
  overflow: hidden;
`

export const SpacerContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  padding: 0 20px;
  visibility: hidden;
  overflow: hidden;
`

export const ScrollingContent = styled.div<{ animated?: boolean, contentWidth?: number, scrollBy?: number }>`
margin: 0 auto;
display: flex;
padding: 0 20px;
> * {
  flex: 1;
  width: 100%;
}
width: 100vw;
height: 100%;
@media (max-width: 670px) {
  flex-wrap: wrap;
  > * {
    margin-bottom: 20px;
    padding-bottom: 20px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  > :last-child {
    margin-bottom: 0;
    padding-bottom: none !important;
    border-bottom: none;
  }
}
position: absolute;
left: 0;
top: 20px;
${props => props.animated && props.contentWidth && css`
  width: ${props.contentWidth}px;
  animation: quotesmove ${props.contentWidth / 100}s linear infinite;
  animation-play-state: running;
  animation-delay: 3s;
  :hover {
    animation-play-state: paused;
  }
  @keyframes quotesmove {
    0% {transform: translateX(0px) }
    100% { transform: translateX(-${props.scrollBy}px) }
  }
`}
`

export const Content = styled.div<{ contentWidth?: number, scrollBy?: number, nbItems?: number }>`
  margin: 0 auto;
  display: flex;
  padding: 0 20px;
  > * {
    flex: 1;
    width: 100%;
  }
  width: 100vw;
  height: 100%;
  @media (max-width: 670px) {
    flex-wrap: wrap;
    > * {
      margin-bottom: 20px;
      padding-bottom: 20px !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    > :last-child {
      margin-bottom: 0;
      padding-bottom: none !important;
      border-bottom: none;
    }
  }

  position: absolute;
  width: 100%;
  left: 0;
  top: 20px;
  justify-content: center;
  &.animated {
    ${props => props.contentWidth && props.scrollBy && props.nbItems && css`
      width: ${props.contentWidth}px;
      justify-content: normal;
      animation: quotesmove ${60 * props.nbItems / 10}s linear infinite;
      animation-play-state: running;
      animation-delay: 3s;
      :hover {
        animation-play-state: paused;
      }
      @keyframes quotesmove {
        0% {transform: translateX(0px) }
        100% { transform: translateX(-${props.scrollBy}px) }
      }
    `}
  }
`

export const Quote = styled.div`
  padding: 10px 10px;
  text-align: center;
  max-width: 315px;
  min-width: 315px;
  > :first-child {
    * {
      object-fit: contain !important;
    }
    max-width: 300px;
  }
  > :nth-child(3),
  > :last-child {
    font-weight: 700;
  }

  &.quote-0 {
    // 
  }
`